import styled from "styled-components"
import {Card as CardBase} from "@irati/ui/src/Layout"

const EMPTY_CARD_HEIGHT = "134px"

const Card = styled(CardBase)`
  background-color: ${(props) => props.color};
  display: flex;
  flex-direction: row;
  margin: 10px 0;
  width: auto;
  min-height: ${EMPTY_CARD_HEIGHT};
  cursor: ${(props) => (props.onClick ? "pointer" : "auto")};
  padding: ${({theme}) => theme.spacing.one};
`

export default Card
